import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-statistics",
  "use": "icon-statistics-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-statistics\"><path d=\"M512 96V512h416v32a448 448 0 1 1-448-448H512zM448 161.344l-10.752 1.024a384 384 0 1 0 424.384 424.384L862.592 576H448V161.344zM640 32A352 352 0 0 1 992 384v32h-384v-384z m32 65.792V352h254.144l-0.896-8.192a288.192 288.192 0 0 0-245.12-245.056l-8.128-0.96z\" p-id=\"864\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol